import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import TextField from 'Components/ComponentLibrary/Components/Uncategorized/TextField';
import InputAdornment from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/InputAdornment';
import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';
import SaveIcon from '@material-ui/icons/Save';
import CheckIcon from 'Components/ComponentLibrary/Molecules/Inputs/SensitiveInfoInputPicker/CheckIcon';
import { useSensitiveInfoInputContext } from '../../Context';

const styles = () => ({
  root: {},
});

const UnlockedInput = ({
  className,
  classes,
  error,
  label,
  helperText,
  onChange,
  InputComponent,
}) => {
  const {
    fieldValue,
    writeOnly,
    submitSensitiveInfoResource,
  } = useSensitiveInfoInputContext();
  const [value, setValue] = React.useState(fieldValue);

  return (
    <TextField
      className={classNames(className, classes.root)}
      error={error}
      label={label}
      onChange={(v) => {
        if (writeOnly) {
          onChange(v);
        }
        setValue(v);
      }}
      helperText={helperText}
      value={value}
      InputProps={{
        inputComponent: InputComponent,
        endAdornment: (writeOnly) ? (
          <InputAdornment position="end">
            <CheckIcon color={'secondary'} />
          </InputAdornment>
        ) : (
          <IconButton
            className={classNames(className, classes.root)}
            icon={SaveIcon}
            aria-label={'Save'}
            title={'Save Field'}
            onClick={() => {
              submitSensitiveInfoResource(value);
            }}
            onMouseDown={(event) => event.preventDefault()}
            color={'primary'}
          />
        ),
      }}
    />
  );
};

UnlockedInput.defaultProps = {
  className: '',
  helperText: null,
  error: null,
  InputComponent: undefined,
};

UnlockedInput.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  InputComponent: PropTypes.object,
};

export default withStyles(styles)(UnlockedInput);
